import "../styles/ProvisionManagementPage.css";

import useProvision from "../hooks/useProvision";
import useProvisionForm from "../hooks/useProvisionForm";

import ProvisionToolbar from "../components/ProvisionToolbar/ProvisionToolbar";
import ProvisionStats from "../components/ProvisionStats/ProvisionStats";
import ProvisionGrid from "../components/ProvisionGrid/ProvisionGrid";

import AddEditProvisionModal from "../components/AddEditProvisionModal/AddEditProvisionModal";
import ProvisionDetailsModal from "../components/ProvisionDetailsModal/ProvisionDetailsModal";
import DeleteModal from "../components/DeleteModal/DeleteModal";
import EmptyState from "../components/EmptyState/EmptyState";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
function ProvisionManagementPage() {
  const {
    products,
    loading,
    deleteLoading,

    fetchProducts,

    search,
    setSearch,

    category,
    setCategory,

    selectedProduct,

    showForm,
    showDetails,
    showDelete,

    openAddModal,
    openEditModal,
    openDetailsModal,
    openDeleteModal,

    closeModals,

    deleteProduct,
  } = useProvision();

  const {
    formData,
    updateField,
    submitForm,
    loading: formLoading,
  } = useProvisionForm(
    selectedProduct,
    fetchProducts,
    closeModals
  );

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="provision-management-page">

      <ProvisionToolbar
        search={search}
        setSearch={setSearch}
        category={category}
        setCategory={setCategory}
        onAdd={openAddModal}
      />

      <ProvisionStats products={products} />

      {products.length === 0 ? (
        <EmptyState
          title="No Products Found"
          subtitle="Start by adding your first provision product."
        />
      ) : (
        <ProvisionGrid
          products={products}
          onView={openDetailsModal}
          onEdit={openEditModal}
          onDelete={openDeleteModal}
        />
      )}

      <AddEditProvisionModal
        isOpen={showForm}
        onClose={closeModals}
        formData={formData}
        updateField={updateField}
        submitForm={submitForm}
        loading={formLoading}
        editingProduct={selectedProduct}
      />

      <ProvisionDetailsModal
        isOpen={showDetails}
        onClose={closeModals}
        product={selectedProduct}
      />

      <DeleteModal
        isOpen={showDelete}
        onClose={closeModals}
        onConfirm={deleteProduct}
        loading={deleteLoading}
        title="Delete Product"
        message="Are you sure you want to delete this product?"
      />

    </div>
  );
}

export default ProvisionManagementPage;